import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    emoji: '⚡',
    title: 'Mental Load Liberation',
    desc: 'Open the vault, choose the volume according to your class, and teach. Planning is done.'
  }, {
    emoji: '👑',
    title: 'Authority and Confidence',
    desc: "Arrive at the studio with an expert's posture and the right words to guide your clients."
  }, {
    emoji: '🌿',
    title: 'True Student Progression',
    desc: 'Biomechanically sound sequences so your students notice results and keep coming back.'
  }, {
    emoji: '😌',
    title: 'Zero Transition Stress',
    desc: 'Master the art of liquid connections for a perfect flow that will impress your clients.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-17">
            WHAT IS GOING TO CHANGE
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-18">
            What will change in your{' '}
            <span className="italic text-pilates-rose" data-id="element-19">professional life</span>
          </h2>
          <p className="text-pilates-slate text-lg max-w-2xl mx-auto" data-id="element-20">
            Real benefits starting from the first week:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-21">
          {benefits.map((b, idx) => <div key={idx} className="bg-pilates-cream rounded-2xl p-7 border border-pilates-sage/15 hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-22">
              <div className="text-4xl mb-3" data-id="element-23">{b.emoji}</div>
              <h3 className="font-display font-semibold text-pilates-dark text-xl mb-2 leading-tight" data-id="element-24">
                {b.title}
              </h3>
              <p className="text-pilates-slate text-base leading-relaxed" data-id="element-25">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}